
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/secciones",
      function () {
        return require("private-next-pages/secciones/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/secciones"])
      });
    }
  